import React from 'react';
import { Button, Col, Input, Row } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';

export default function FAQ({ Form }) {
	return (
		<Form.List name='faq'>
			{(fields, { add, remove }) => (
				<>
					<div className='page-header' style={{ marginBottom: 16 }}>
						<div className='page-title'>FAQ</div>
						<div className='page-title-more'>
							<Button
								icon={<PlusOutlined />}
								type='primary'
								onClick={() => {
									add();
								}}
								style={{ width: '100%' }}
							>
								Add FAQ
							</Button>
						</div>
					</div>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={10}>
								<Form.Item label='Question' name={[name, 'question']}>
									<Input.TextArea rows={2} />
								</Form.Item>
							</Col>
							<Col sm={24} md={13}>
								<Form.Item label='Answer' name={[name, 'answer']}>
									<Input.TextArea style={{ width: '100%' }} rows={2} />
								</Form.Item>
							</Col>
							<Col sm={24} md={1}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
						</Row>
					))}
				</>
			)}
		</Form.List>
	);
}
